import * as angular from 'angular';

import { MxPublicService } from './public.service';

export const publicModule: angular.IModule = angular.module('mx.sb.public', []).service('mx.sb.public.service', MxPublicService);
